import React from "react";
import { formatCurrency } from "utils";
import { Stack, Typography } from "@mui/material";
import { green } from "@mui/material/colors";

interface Props<T = Record<string, unknown>[]> {
  values: T[];
  calcKey: keyof T;
}

export const TotalSumOfSection = <T = Record<string, unknown>,>({ values, calcKey }: Props<T>) => {
  if (!values.length) return null;

  const total = values.reduce((sum, value) => {
    if (typeof value[calcKey] === "number") {
      sum += value[calcKey];
    }

    return sum;
  }, 0);

  const formattedTotal = formatCurrency(total, true);

  return (
    <Stack direction="row" gap="0.2rem" alignItems="center">
      <Typography variant="subtitle2" component="span" sx={{ color: green[500] }}>
        Total:{" "}
      </Typography>
      <Typography sx={{ color: green[500], fontSize: "1.1rem", fontWeight: 500 }}>{formattedTotal}</Typography>
    </Stack>
  );
};
